import React, { useEffect, useState } from 'react';
import '../style.scss';
import { SearchNav } from 'views/components/organisms/searchNav';
import { List } from 'views/components/organisms/list';
import { headerShowList } from 'views/constants/const/OrderStatus';
import { GetApplicationListQueryVariables } from 'views/utils/graphql/graphql';
import { useGetOrderStatus } from './hooks/useGetOrderStatus';
import { BodyShowList } from 'views/components/molecules/listBody';
import { createBodyShowLists } from './function/createBodyShowList';
import { Pagination } from 'views/components/atoms/pagination';
import { calcTotalPage } from 'views/utils/calc/pagination';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { OrderDetail } from '../orderDetail';
import { CreateOrderDetailProps } from '../orderDetail/function/createOrderDetail';
import { PageLocationSP } from 'views/components/atoms/pageLocation';

const PAGE_COUNT = 30;

const initialOrderStatusVariables: GetApplicationListQueryVariables = {
  count: PAGE_COUNT,
  page: 1,
  symbolName: '',
};

export const OrderStatus = () => {
  const [selectedSymbol, setSelectedSymbol] = useState<string>('');
  const [selectedSymbolData, setSelectedSymbolData] = useState<CreateOrderDetailProps>();

  const { symbolName, setSymbolName, currentPage, setCurrentPage, setSymbolNameWithFetch, getOrderStatusState } =
    useGetOrderStatus(initialOrderStatusVariables);
  const [bodyShowLists, setBodyShowLists] = useState<BodyShowList[]>([]);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  useEffect(() => {
    if (!getOrderStatusState.data) return;
    setBodyShowLists(createBodyShowLists(getOrderStatusState.data));
  }, [getOrderStatusState]);

  return (
    <section className="outletWrapper">
      <div className="centerContent">
        <PageLocationSP />
        {/* 検索欄 */}
        <SearchNav
          searchWord={symbolName}
          setSearchWord={setSymbolName}
          submitSearch={setSymbolNameWithFetch}
          clearSearch={() => setSymbolNameWithFetch('')}
          placeholder="銘柄名"
        />
        {/* 顧客リスト */}
        <List
          headerShowList={headerShowList}
          bodyShowLists={bodyShowLists}
          onClick={(index) => {
            setIsOpenModal(true);
            if (!getOrderStatusState.data?.GetApplicationList?.Data) return;
            const data = getOrderStatusState.data.GetApplicationList.Data[index];
            setSelectedSymbol(data?.Symbol || '');

            const param: CreateOrderDetailProps = {
              Status: data?.Status || 0,
              SymbolName: data?.SymbolName || '',
              TotalApplicationQuantity: data?.TotalApplicationQuantity || 0,
              TotalPurchaseQuantity: data?.TotalPurchaseQuantity || 0,
              LatestApplicationDateTime: data?.LatestApplicationDateTime || '',
            };
            setSelectedSymbolData(param);
          }}
          loading={getOrderStatusState.fetching}
        />
        {/* ページネーション */}
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageCount={calcTotalPage(getOrderStatusState.data?.GetApplicationList?.TotalCount || 1, PAGE_COUNT) || 1}
          fetchApi={() => {}} // useGetOrderStatus内で行うためここでは何もしない
        />
      </div>
      <ModalBase
        isOpen={isOpenModal}
        onRequestClose={() => setIsOpenModal(false)}
        modalStyle={ModalStyle.confirmModal}
        children={
          <OrderDetail symbol={selectedSymbol || ''} data={selectedSymbolData} setCloseModal={setIsOpenModal} />
        }
      />
    </section>
  );
};
